import { createReducer, on } from '@ngrx/store';
import { setScatterPlot } from '../scatter-plot.actions';
import { setChartOption } from './chart-options.actions';
import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
export const displayLegend = createReducer(true, on(setChartOption, (state, action) => {
    if (action.chartOption.value === ScatterPlotChartOptionValue.displayLegend) {
        return action.chartOption.selected;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.displayLegend;
}));
